





































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { GetPathology, DeletePathologyData } from "@/api/hd";
import ajax from "axios";
import addPathology from "./addOrEditPathology.vue";
import imagePathology from "./imagePathology.vue";
@Component({
  components: { addPathology, imagePathology },
})
export default class extends AbpBase {
  @Prop() patient: any;
  data: any = [];
  tableData = [];
  date = [];
  page = 1;
  totalCount = 0;
  loading = false;
  reportShow = false;
  asyncLoading = false;
  highlightRow: any = {};
  reportData: any = {};
  addPathologyShow = false;
  PathologyData: any = {};
  tabChange(val: any) {
    this.highlightRow = val;
  }

  get minHeight() {
    return window.innerHeight - 200;
  }
  pageChange(val: number) {
    this.page = val;
    this.getData();
  }
  options = {
    shortcuts: [
      {
        text: "一周",
        value() {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
          return [start, end];
        },
      },
      {
        text: "一个月",
        value() {
          const end = new Date();
          const start = new Date(
            end.getFullYear(),
            end.getMonth() - 1,
            end.getDate() - 1
          );
          return [start, end];
        },
      },
      {
        text: "三个月",
        value() {
          const end = new Date();
          const start = new Date(
            end.getFullYear(),
            end.getMonth() - 3,
            end.getDate() - 1
          );
          return [start, end];
        },
      },
      {
        text: "一年",
        value() {
          const end = new Date();
          const start = new Date(
            end.getFullYear() - 1,
            end.getMonth(),
            end.getDate() - 1
          );
          return [start, end];
        },
      },
    ],
  };
  columns = [
    {
      title: "送检日期",
      key: "inspectionDate",
      width: 204,
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        return h("div", this.formatDateTime(p.row.inspectionDate));
      },
    },
    {
      title: "送检材料",
      key: "checkMaterial",
      width: 110,
    },
    {
      title: "临床诊断",
      key: "clinicalDiagnosis",
    },
    {
      title: "操作",
      width: 220,
      render: (h1: any, p: any) => {
        const h = this.$createElement;

        return h("div", [
          h(
            "Button",
            {
              props: {
                size: "small",
                type: "primary",
              },
              on: {
                click: () => {
                  this.editPathologyData(p.row);
                },
              },
            },
            "编辑"
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              style: {
                marginLeft: "15px",
              },
              on: {
                click: () => {
                  this.delPathology(p.row);
                },
              },
            },
            "删除"
          ),
          h(
            p.row.mirrorUnder ? "Button" : "",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginLeft: "15px",
              },
              on: {
                click: () => {
                  this.showImage(p.row);
                },
              },
            },
            "报告"
          ),
        ]);
      },
    },
  ];

  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
    this.date = [start, end];
    this.getData();
  }
  showReport(row: any) {
    this.reportShow = true;
    this.reportData = row;
  }
  async getData() {
    this.loading = true;
    let res = await GetPathology({
      StartDate: this.formatDate(this.date[0]),
      EndDate: this.formatDate(this.date[1]),
      PatientId: this.patient.pD_Patient_ID,
      SkipCount: this.page,
      MaxResultCount: 10,
    });
    this.data = res.items;
    this.totalCount = res.totalCount;
    if (this.data.length) {
      this.data[0]._highlight = true;
      this.highlightRow = this.data[0];
    } else {
      this.highlightRow = {};
    }
    this.loading = false;
  }

  async asyncInfo() {
    this.asyncLoading = true;
    setTimeout(() => {
      this.asyncLoading = false;
    }, 2000);
  }
  addPathologyData() {
    this.PathologyData = {
      saveType: "新增",
      inspectionDate: new Date(),
      patientId: this.patient.pD_Patient_ID,
    };
    this.addPathologyShow = true;
  }
  editPathologyData(PathologyData: any) {
    this.PathologyData = PathologyData;
    this.PathologyData.saveType = "编辑";
    this.addPathologyShow = true;
  }
  delPathology(PathologyData: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "此操作将永久删除该记录, 是否继续?",
      onOk: async () => {
        let res = await DeletePathologyData({ Id: PathologyData.id });
        this.getData();
      },
    });
  }
  showImagePathology = false;
  imagePathology = {};
  showImage(PathologyData: any) {
    this.imagePathology = PathologyData;
    this.showImagePathology = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pathologyManage/parts/pathologicdiagnosis/index.vue